import type { Fbq } from '~analytics/providers/MetaPixelProvider';

interface PixelAnalytics {
  proxy: {
    fbq: Fbq;
  };
}

export const loadMetaPixel = (id: string): PixelAnalytics =>
  <PixelAnalytics>(<unknown>useScriptMetaPixel({ id }));
